import { render } from "./ApiTokens.vue?vue&type=template&id=08764900&scoped=true"
import script from "./ApiTokens.vue?vue&type=script&lang=js"
export * from "./ApiTokens.vue?vue&type=script&lang=js"

import "./ApiTokens.vue?vue&type=style&index=0&id=08764900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08764900"]])

export default __exports__